import { object, string } from "yup";

export const alarmRuleSchema = object({
  name: string().required("Name is required"),
  display_name: string().required("Display name is required"),
  date_type: string().required("Date type is required"),
  deadline_month: string().required("Deadline month is required"),
});
